import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, CloseButton, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Iobserver, LoginInfo } from '../App';
import { isLoggin } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { t } from 'i18next';
import EditPopup from './EditPopup';
import ImageViewPopup from './ImageViewPopup';
import EventViewPopup from './EventViewPopup';
import TextViewPopup from './TextViewPopup';
import { imgPath, planDialog } from '../service/CommonUtil';
import TextEditPopup from './TextEditPopup';
import EventEditPopup from './EventEditPopup';
import VideoViewPopup from './VideoViewPopup';
import VideoEditPopup from './VideoEditPopup';
import MuiButton from "@mui/material/Button";
import PostLimit from './upload/PostLimit';
import CharacterEditPopup from './CharacterEditPopup';

const CreatorManage = () => {
    async function getList(type,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/my3Days/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImage(type,groupId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/post/"+groupId).then((r)=>r.json().then((d)=>{
            return d
        }))
    }
    async function setCreatorDisplay(groupId,flag){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+type+"/creatorDisplay/",{groupId:groupId,flag:flag}).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate();
    // 画像遅延ロード
    const observer = useContext(Iobserver)

    // URLパラメータ
    let param = useParams();

    const [type,setType] = useState('image')
    const [imageList,setImageList] = useState([...Array(0)])
    const [message,setMessage] = useState('')
    const [item, selectItem] = useState('')
    const [deleted, setDeleted] = useState('')

    // 検索情報
    const [page,setPage] = useState(0)

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    // 初期処理とページ遷移
    useEffect(() =>{
        // タイトル設定
        document.querySelector("title").textContent = t("manage.title") + " - アワートAI"

        let currentPage = 1
        if(param.page === undefined){
            currentPage = 1
        } else {
            currentPage = parseInt(param.page)
        }
        setPage(currentPage)
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(page > 0){
            if(loginInfo.result){ // ログイン確認が終わるまで待機する必要あり。
                getList(type,currentPage).then(json => {
                    if(json.result){
                        if(json.data.length > 0){
                            setMessage("")
                        } else {
                            setMessage("まだ投稿がありません。あなたも投稿してみませんか？")
                        }
                        // スクロールを最上位に戻す
                        window.scrollTo({top:0,left:0,behavior:"instant"})
                        setImageList(json.data)
                    }
                })
            }
        }
    },[loginInfo,deleted,page,type])

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList])

    // 削除ボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            deleteImage(type,item).then(r=>{
                if(r.result){
                    setDeleted(item)
                } else {
                    dialog("エラー",r.errors)
                }
                setOkButtonShow(false)
            })
        }}>OK</Button>
    }
    const [showEditPopup,setShowEditPopup] = useState(false)
    const [groupId,setGroupId] = useState("")
    const [showImageViewPopup,setShowImageViewPopup] = useState(false)
    const [showVideoViewPopup,setShowVideoViewPopup] = useState(false)
    const [showTextViewPopup,setShowTextViewPopup] = useState(false)
    const [showEventViewPopup,setShowEventViewPopup] = useState(false)
    const [index,setIndex] = useState(0)
    function imageUrl(data,type){
        if(type === "video"){
            if(data.status >= 4){
                return ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST) + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
            } else {
                return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath(type) + '/encode.webp'
            }
        } else {
            return ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST) + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
        }
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton} />
        {showEditPopup && type === "character" ? <CharacterEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "image" ? <EditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "video" ? <VideoEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "text" ? <TextEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showEditPopup && type === "event" ? <EventEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showImageViewPopup ? <ImageViewPopup groupId={groupId} switch={setShowImageViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        {showVideoViewPopup ? <VideoViewPopup groupId={groupId} switch={setShowVideoViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        {showTextViewPopup ? <TextViewPopup groupId={groupId} switch={setShowTextViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        {showEventViewPopup ? <EventViewPopup groupId={groupId} switch={setShowEventViewPopup} i={index} list={imageList} listName={t("manage.title")} /> : ""}
        <Header />
        <Category />
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",display:"block",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>公認欄の作品選択</Container>
        <Container>トップページの「公認クリエイター」欄に表示される作品を選択します。選択すると投稿から3日間の間表示されます。選択のない場合は最新の投稿が表示されます。<br />反映までには数時間かかります。</Container>
        <Container className='d-none'>
            <MuiButton variant={type === "character" ? "contained" : "outlined"} onClick={() => setType("character")} className='m-1'>キャラクター</MuiButton>
            <MuiButton variant={type === "image" ? "contained" : "outlined"} onClick={() => setType("image")} className='m-1'>{t("upload.image.title")}</MuiButton>
            <MuiButton variant={type === "video" ? "contained" : "outlined"} onClick={() => setType("video")} className='m-1'>{t("upload.video.title")}</MuiButton>
            <MuiButton variant={type === "text" ? "contained" : "outlined"} onClick={() => setType("text")} className='m-1'>{t("upload.text.title")}</MuiButton>
            <MuiButton variant={type === "event" ? "contained" : "outlined"} onClick={() => setType("event")} className='m-1'>{t("upload.event.title")}</MuiButton>
        </Container>
        {type === "image" ? <PostLimit /> : ""}
        <Container>
            {type === "image" && imageList.find(data => data.problem_status === 1) !== undefined ? <>
                <Alert variant='danger'>
                    <Icon.ExclamationCircle /> 対応が必要な投稿があります。削除または修正され、審査が完了するまで非公開状態になります。また、対応が完了するまで新規の投稿はできません。
                    <ul>
                    {imageList.filter(d => d.problem_status !== 0).map(d => {
                        return <li style={{cursor:"pointer"}} onClick={() => {
                            setShowEditPopup(true)
                            setGroupId(d.group_id)
                        }}>{d.title}</li>
                    })}
                    </ul>
                </Alert>
            </> : ""}
        </Container>
        <Container className='d-flex flex-row justify-content-start flex-wrap w-100'>
            {message}
            {imageList.map((data,i) => {
                if(i === 100){
                    return ""
                }
            return <Container style={{position:"relative",width:"180px"}} className="mb-3 p-0" key={i}>
                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 3 ? "block":"none"}}>
                                R-15
                            </Badge>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 4 ? "block":"none"}}>
                                R-18
                            </Badge>
                            <Badge bg="danger" style={{position:"absolute",zIndex:"1",top:"20px",left:"20px",display:data.age_limit === 5 ? "block":"none"}}>
                                R-18G
                            </Badge>
                            <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px",display:data.img_count > 1 ? "block":"none"}}>
                                <Icon.CollectionFill /> {data.img_count}
                            </Badge>
                            <CloseButton style={{position:"absolute",zIndex:"1",top:"20px",right:"20px",backgroundColor:"#FFFFFF"}} onClick={()=>{
                                selectItem(data.group_id)
                                setOkButtonShow(true)
                                dialog("確認",
                                    <Container style={{margin:"0 auto"}}>
                                        <Container className='text-center'>{t("common.delete")}</Container>
                                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                                            <Image src={imageUrl(data,type)} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",borderRadius:"20px"}} className="p-2" />
                                        </Container>
                                        <Container style={{fontWeight:"bold",fontSize:"15px"}} className='text-center'>{data.title}</Container>
                                    </Container>
                                    )
                            }} />
                            <Badge bg="white" style={{display:type === "video" && data.status === 4 ? "block" : "none",cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",left:"20px"}}
                                onClick={() => {
                                    dialog(t("common.info"),<div>動画を公開するには、必須情報の登録が必要です。<br />編集画面からタイトル等を設定してください。</div>)
                                }}>
                                <Icon.ExclamationCircle style={{color:"#FF0000",fontSize:"18px"}} />
                            </Badge>
                            <Badge bg="white" style={{cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",right:"50px"}}
                                onClick={() => {
                                    setShowEditPopup(true)
                                    setGroupId(data.group_id)
                                }}>
                                <Icon.PencilSquare style={{color:"#000000"}} /> <span style={{color:"#555555"}}>{t("common.edit")}</span>
                            </Badge>
                            <Badge bg="secondary" style={{cursor:"pointer",position:"absolute",padding:"3px",zIndex:1,bottom:"20px",right:"50px",display:data.limited_publication === 1 ? "block":"none"}}>
                                <Icon.EyeFill style={{color:"#FFFFFF",fontSize:"16px"}} />
                            </Badge>
                            <Badge bg="secondary" style={{cursor:"pointer",position:"absolute",padding:"3px",zIndex:1,bottom:"20px",left:"20px",display:data.booking_flg === 1 ? "block":"none"}}>
                                <RIcon.FaHistory title={t("common.booking")} style={{color:"#FFFFFF",fontSize:"16px"}} />
                            </Badge>
                            <FavoriteIcon type={type} id={data.group_id} style={{fontSize:"18px",cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} favorite={data.favorite} dialog={dialog} count={data.favorite_count} />
                            <Image
                            onClick={() => {
                                setGroupId(data.group_id)
                                setIndex(i)
                                if(type === 'character'){
                                    navigate("/character/"+data.group_id)
                                } else if(type === 'image'){
                                    setShowImageViewPopup(true)
                                } else if(type === 'video'){
                                    setShowVideoViewPopup(true)
                                } else if(type === 'text'){
                                    setShowTextViewPopup(true)
                                } else if(type === 'event'){
                                    setShowEventViewPopup(true)
                                }
                            }}
                            loading="lazy" src={imageUrl(data,type)}
                            style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="p-2" key={i} />
                        </Container>
                        <Container style={{fontWeight:"bold",fontSize:"15px"}}>
                            {type === "image" && data.problem_status === 1 ? <><Icon.ExclamationCircle style={{color:"red"}} />&nbsp;</> : ""}
                            {type === "image" && data.problem_status === 2 ? <><Icon.InfoCircle style={{color:"red",cursor:"pointer"}} title="審査中" onClick={() => dialog("","再公開の審査中です。")}/>&nbsp;</> : ""}
                            <Link to={"/"+type+"/"+(data.group_id)} style={{color:"#555555",textDecoration:"none"}}>{type === 'character' ? <><ruby> {data.character_name} <rp>(</rp><rt>{data.character_name_kana}</rt><rp>)</rp> </ruby></> : data.title}</Link>
                        </Container>
                        <MuiButton className='w-100' variant={data.creator_display === 1 ? 'contained' : 'outlined'}
                        onClick={() => {
                            setCreatorDisplay(data.group_id,data.creator_display === 1 ? 0 : 1).then(r => {
                                if(r.result){
                                    getList(type,1).then(r => {
                                        if(r.result){
                                            setImageList(r.data)
                                        }
                                    })
                                }
                            })
                        }}
                        >{data.creator_display === 1 ? "選択中" : "選択"}</MuiButton>
                    </Container>
            })}
        </Container>
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {page > 1 ? (
                    <MuiButton variant='outlined' onClick={() => {
                        let p = page - 1
                        setPage(p)
                        navigate("/manage/" + p)
                    } }>{t("common.prev")}</MuiButton>
                ) : <MuiButton variant='outlined' disabled>{t("common.prev")}</MuiButton>}
            {imageList.length > 100 ? (
                    <MuiButton variant='outlined' onClick={() => {
                        let p = page + 1
                        setPage(p)
                        navigate("/manage/" + p)
                    } }>{t("common.next")}</MuiButton>
                ) : <MuiButton variant='outlined' disabled>{t("common.next")}</MuiButton>}
        </Container>
        <Footer />
    </div>
    )
}

export default CreatorManage;
